import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./App.css";

const quotes = [
  ["Go then. There are other worlds than these."],
  ["Death, but not for you, gunslinger."],
  ["We go to seek a better world.", "May you find one as well."],
  ["The man in black fled across the desert,", "and the gunslinger followed."],
  [
    "All is forgotten in the stone halls of the dead.",
    "These are the rooms of ruin where the spiders spin,",
    "and the great circuits fall quiet, one by one."
  ],
  ["Wish in one hand, shit in the other,", "see which one fills up first."],
  [
    "And so, in the end, the clearing at the end of the path was a loop,",
    "and the wheel turned again."
  ],
  ["We are ka-tet, one from many."],
  [
    "Oy stretched his neck up,",
    "licked Roland’s face once,",
    "and whispered: ‘Olan.’",
    "He sighed a little sigh and died."
  ]
];

const finalQuote = ["Remember the face of your father."];

export default function App() {
  const [currentQuote, setCurrentQuote] = useState([]);
  const [showFinal, setShowFinal] = useState(false);

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * quotes.length);
    setCurrentQuote(quotes[randomIndex]);

    const delay = Math.floor(Math.random() * 3000) + 8000; // 8–11 seconds
    const timer = setTimeout(() => {
      setShowFinal(true);
      setCurrentQuote(finalQuote);
    }, delay);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className="background"
      style={{
        backgroundImage: 'url("/tower-desktop.webp")',
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        width: "100vw",
        height: "100vh"
      }}
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 3 }}
        className="background-overlay"
      />
      <AnimatePresence mode="wait">
        <motion.h1
          key={showFinal ? "final" : "initial"}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.2 }}
          className="quote"
        >
          {currentQuote.map((line, index) => (
            <span className="line" key={index}>
              {line}
            </span>
          ))}
        </motion.h1>
      </AnimatePresence>
    </div>
  );
}
